const basePath = resourceId => `mobile_app/v2/ticketing/product/items/${resourceId}`

export default {
  /**
   * index() lista instancias de soportes
   * */
  async index(params) {
    const response = await Vue.http.get(basePath(''), {params})

    return response.data
  },

  /**
   * show() obtiene una instancia de soporte
   * */
  async show(id, params) {
    const response = await Vue.http.get(basePath(id), {params})

    return response.data.data
  },

  /**
   * count() cuenta instancias de soportes
   * */
  async count(params) {
    const response = await Vue.http.get(basePath('count'), {params})

    return response.data.data
  }
}
